import { Address } from "@models/address/address";
import { Company } from "@models/companies/company";
import { Entity } from "@models/companies/entity";
import { Document } from "@models/documents/document";
import { EntityChangeData } from "@models/documents/entity-change-data";
import { Relationship } from "@models/relationships/relationship";
import { JurisdictionType, TrustSubType, TrustType } from "@models/trusts/trusts-enums";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

export class TrustEstablishmentBase extends EntityChangeData {
  trustName: string;
  trustType: TrustType;
  subType: TrustSubType;
  jurisdiction: JurisdictionType | null;
  meetingAddress: Address;
  trustees: Relationship[]; // settlor, trustee, appointor, beneficiary, unitholders

  constructor(data: Partial<TrustEstablishmentBase> = {}) {
    super(data);

    this.trustName = data.trustName ?? '';
    this.trustType = data.trustType!;
    this.subType = data.subType!;
    this.jurisdiction = data.jurisdiction ?? null;
    this.meetingAddress = new Address(data.meetingAddress ?? {});
    this.trustees = (data.trustees ?? []).map((relationship) => new Relationship(relationship)) ?? [];
  }

  toDictionary(entity: Entity): { key: string, value: string }[] {
    return [];
  }

  fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    return modalRef;
  }

  fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit: boolean): NgbModalRef {
    return modalRef;
  }
}
